<template>
  <div>
    <!-- 平台汇总卡片 -->
    <div class="row mb-3">
      <div class="col-xl-3 col-sm-6 mb-xl-0 mb-3">
        <div class="card">
          <div class="card-body p-3">
            <div class="d-flex align-items-center">
              <div class="bg-gradient-success icon-shape rounded-circle me-3" style="width:48px;height:48px;display:flex;align-items:center;justify-content:center;">
                <i class="ni ni-money-coins text-white" style="font-size:1.2rem;"></i>
              </div>
              <div>
                <p class="text-xs text-secondary mb-0">总交易额</p>
                <h6 class="mb-0">¥{{ formatMoney(sumData.totalFee) }}</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-sm-6 mb-xl-0 mb-3">
        <div class="card">
          <div class="card-body p-3">
            <div class="d-flex align-items-center">
              <div class="bg-gradient-info icon-shape rounded-circle me-3" style="width:48px;height:48px;display:flex;align-items:center;justify-content:center;">
                <i class="ni ni-bag text-white" style="font-size:1.2rem;"></i>
              </div>
              <div>
                <p class="text-xs text-secondary mb-0">净收入</p>
                <h6 class="mb-0">¥{{ formatMoney(sumData.netFee) }}</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xl-3 col-sm-6 mb-xl-0 mb-3">
        <div class="card">
          <div class="card-body p-3">
            <div class="d-flex align-items-center">
              <div class="bg-gradient-danger icon-shape rounded-circle me-3" style="width:48px;height:48px;display:flex;align-items:center;justify-content:center;">
                <i class="ni ni-fat-rm text-white" style="font-size:1.2rem;"></i>
              </div>
              <div>
                <p class="text-xs text-secondary mb-0">退款总额</p>
                <h6 class="mb-0">¥{{ formatMoney(sumData.refundFee) }}</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <!-- 收入构成饼图 -->
      <div class="col-lg-5 mb-3">
        <div class="card h-100">
          <div class="card-header pb-0">
            <h6>收入构成分析</h6>
            <p class="text-xs text-secondary">直购 / 挑战 / 充值收入占比</p>
          </div>
          <div class="card-body p-3">
            <canvas id="incomePieChart" height="200"></canvas>
            <div v-if="challengeData.total === 0" class="text-center text-secondary text-xs py-4">暂无数据</div>
          </div>
        </div>
      </div>

      <!-- 按天分类收入趋势 -->
      <div class="col-lg-7 mb-3">
        <div class="card h-100">
          <div class="card-header pb-0">
            <h6>按天分类收入趋势</h6>
            <p class="text-xs text-secondary">直购 / 挑战 / 充值 每日收入</p>
          </div>
          <div class="card-body p-3">
            <canvas id="categoryTrendChart" height="200"></canvas>
            <div v-if="categoryBreakdown.length === 0" class="text-center text-secondary text-xs py-4">暂无数据</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 平台交易趋势（原趋势图保留在下方） -->
    <div class="row mb-3">
      <div class="col-12">
        <div class="card">
          <div class="card-header pb-0">
            <h6>平台交易趋势</h6>
            <p class="text-xs text-secondary">近 {{ days }} 天每日交易额</p>
          </div>
          <div class="card-body p-3">
            <canvas id="overviewTrendChart" height="100"></canvas>
            <div v-if="trendData.length === 0" class="text-center text-secondary text-xs py-4">暂无数据</div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <!-- 今日实时概览 -->
      <div class="col-lg-5 mb-3">
        <div class="card h-100">
          <div class="card-header pb-0 d-flex justify-content-between align-items-center">
            <div>
              <h6>今日实时概览</h6>
              <p class="text-xs text-secondary">今日全平台收入</p>
            </div>
            <button class="btn btn-sm btn-outline-info" @click="fetchTodayData">
              <i class="ni ni-refresh"></i> 刷新
            </button>
          </div>
          <div class="card-body p-3">
            <div v-if="todayLoading" class="text-center text-secondary text-xs py-4">加载中...</div>
            <div v-else>
              <div class="d-flex justify-content-around mb-3">
                <div class="text-center">
                  <p class="text-xs text-secondary mb-0">今日总额</p>
                  <h5 class="text-success">¥{{ formatMoney(todaySummary.sumFee) }}</h5>
                </div>
                <div class="text-center">
                  <p class="text-xs text-secondary mb-0">今日净收</p>
                  <h5 class="text-info">¥{{ formatMoney(todaySummary.netFee) }}</h5>
                </div>
              </div>
              <div v-if="todayItems.length > 0" class="table-responsive">
                <table class="table table-sm align-items-center mb-0">
                  <thead>
                    <tr>
                      <th class="text-xs text-secondary">设备ID</th>
                      <th class="text-xs text-secondary text-end">金额</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in todayItems.slice(0, 5)" :key="item.board_id">
                      <td class="text-xs">{{ item.board_id }}</td>
                      <td class="text-xs text-end">¥{{ formatMoney(item.sum_fee) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-else class="text-center text-secondary text-xs py-3">今日暂无交易数据</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 最新订单流 -->
      <div class="col-lg-7 mb-3">
        <div class="card h-100">
          <div class="card-header pb-0 d-flex justify-content-between align-items-center">
            <div>
              <h6>最新订单流</h6>
              <p class="text-xs text-secondary">全平台最近订单</p>
            </div>
            <button class="btn btn-sm btn-outline-info" @click="fetchNewestOrders">
              <i class="ni ni-refresh"></i> 刷新
            </button>
          </div>
          <div class="card-body p-3">
            <div v-if="orderLoading" class="text-center text-secondary text-xs py-4">加载中...</div>
            <div v-else-if="newestOrders.length > 0" class="table-responsive">
              <table class="table table-sm align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-xs text-secondary">序号</th>
                    <th class="text-xs text-secondary">订单号</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(order, idx) in newestOrders.slice(0, 10)" :key="idx">
                    <td class="text-xs">{{ idx + 1 }}</td>
                    <td class="text-xs font-monospace">{{ order }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else class="text-center text-secondary text-xs py-4">暂无订单</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Chart from "chart.js/auto";
import { getSumReports, getTodayIncomes, getNewestOrder, getChallengeSummary, getDailyCategoryBreakdown } from "@/api/dashboard";
import { getSalesTrend } from "@/api/dashboard";

export default {
  name: "PlatformOverview",
  props: {
    days: { type: Number, default: 30 },
    deliverId: { type: Number, default: 0 },
    startDate: { type: Number, required: true },
    endDate: { type: Number, required: true },
  },
  data() {
    return {
      sumData: { totalFee: 0, netFee: 0, refundFee: 0 },
      challengeData: { challengeFee: 0, directFee: 0, rechargeFee: 0, total: 0 },
      trendData: [],
      categoryBreakdown: [],
      todayItems: [],
      todaySummary: { sumFee: 0, netFee: 0 },
      todayLoading: false,
      newestOrders: [],
      orderLoading: false,
    };
  },
  mounted() {
    this.fetchAll();
  },
  methods: {
    formatMoney(fen) {
      if (!fen) return "0.00";
      return (fen / 100).toFixed(2);
    },
    async fetchAll() {
      await Promise.all([
        this.fetchSumReports(),
        this.fetchChallengeSummary(),
        this.fetchTrend(),
        this.fetchCategoryBreakdown(),
        this.fetchTodayData(),
        this.fetchNewestOrders(),
      ]);
      this.$nextTick(() => {
        this.renderPieChart();
        this.renderTrendChart();
        this.renderCategoryTrendChart();
      });
    },
    async fetchCategoryBreakdown() {
      try {
        const params = { start_date: this.startDate, end_date: this.endDate };
        if (this.deliverId > 0) params.deliver_id = this.deliverId;
        const resp = await getDailyCategoryBreakdown(params);
        if (resp.code === 0 && Array.isArray(resp.desc)) {
          this.categoryBreakdown = resp.desc;
        }
      } catch (err) {
        console.error("获取按天分类收入失败:", err);
      }
    },
    renderCategoryTrendChart() {
      const ctx = document.getElementById("categoryTrendChart");
      if (!ctx) return;
      const existing = Chart.getChart("categoryTrendChart");
      if (existing) existing.destroy();
      if (this.categoryBreakdown.length === 0) return;
      const fmtDate = (ts) => {
        const d = new Date(ts * 1000);
        return `${d.getMonth() + 1}/${d.getDate()}`;
      };
      const labels = this.categoryBreakdown.map((d) => fmtDate(d.date));
      new Chart(ctx.getContext("2d"), {
        type: "line",
        data: {
          labels,
          datasets: [
            { label: "直购", data: this.categoryBreakdown.map((d) => d.direct_fee), borderColor: "#3A416F", backgroundColor: "rgba(58,65,111,0.1)", tension: 0.4, borderWidth: 2, pointRadius: 0 },
            { label: "挑战", data: this.categoryBreakdown.map((d) => d.challenge_fee), borderColor: "#cb0c9f", backgroundColor: "rgba(203,12,159,0.1)", tension: 0.4, borderWidth: 2, pointRadius: 0 },
            { label: "充值", data: this.categoryBreakdown.map((d) => d.recharge_points), borderColor: "#189887", backgroundColor: "rgba(24,152,135,0.1)", tension: 0.4, borderWidth: 2, pointRadius: 0 },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: { legend: { position: "bottom", labels: { font: { size: 11 } } } },
          scales: {
            y: { grid: { borderDash: [5, 5] }, ticks: { color: "#b2b9bf", font: { size: 11 } } },
            x: { grid: { display: false }, ticks: { color: "#b2b9bf", font: { size: 11 } } },
          },
        },
      });
    },
    async fetchSumReports() {
      try {
        const params = { start_date: this.startDate, end_date: this.endDate };
        if (this.deliverId > 0) params.deliver_id = this.deliverId;
        const resp = await getSumReports(params);
        if (resp.code === 0 && Array.isArray(resp.desc)) {
          let totalFee = 0, netFee = 0, refundFee = 0;
          resp.desc.forEach((item) => {
            totalFee += item.sum_fee || 0;
            netFee += item.net_fee || 0;
            refundFee += item.refund_sum_fee || 0;
          });
          this.sumData = { totalFee, netFee, refundFee };
        }
      } catch (err) {
        console.error("获取汇总报表失败:", err);
      }
    },
    async fetchChallengeSummary() {
      try {
        const params = { start_date: this.startDate, end_date: this.endDate };
        if (this.deliverId > 0) params.deliver_id = this.deliverId;
        const resp = await getChallengeSummary(params);
        if (resp.code === 0 && Array.isArray(resp.desc)) {
          let challengeFee = 0, directFee = 0, rechargeFee = 0;
          resp.desc.forEach((item) => {
            challengeFee += item.sum_challenge_fee || 0;
            directFee += item.sum_direct_fee || 0;
            rechargeFee += item.sum_recharge_fee || 0;
          });
          this.challengeData = { challengeFee, directFee, rechargeFee, total: challengeFee + directFee + rechargeFee };
        }
      } catch (err) {
        console.error("获取挑战汇总失败:", err);
      }
    },
    async fetchTrend() {
      try {
        const resp = await getSalesTrend({ days: parseInt(this.days) });
        if (resp.code === 0 && Array.isArray(resp.desc)) {
          this.trendData = resp.desc;
        }
      } catch (err) {
        console.error("获取交易趋势失败:", err);
      }
    },
    async fetchTodayData() {
      this.todayLoading = true;
      try {
        const params = {};
        if (this.deliverId > 0) params.deliver_id = this.deliverId;
        const resp = await getTodayIncomes(params);
        if (resp.code === 0 && Array.isArray(resp.desc)) {
          this.todayItems = resp.desc;
          let sumFee = 0, netFee = 0;
          resp.desc.forEach((item) => {
            sumFee += item.sum_fee || 0;
            netFee += item.net_fee || 0;
          });
          this.todaySummary = { sumFee, netFee };
        }
      } catch (err) {
        console.error("获取今日收入失败:", err);
      } finally {
        this.todayLoading = false;
      }
    },
    async fetchNewestOrders() {
      this.orderLoading = true;
      try {
        const resp = await getNewestOrder({});
        if (resp.code === 0) {
          if (Array.isArray(resp.desc)) {
            this.newestOrders = resp.desc;
          } else if (typeof resp.desc === "string") {
            this.newestOrders = [resp.desc];
          }
        }
      } catch (err) {
        console.error("获取最新订单失败:", err);
      } finally {
        this.orderLoading = false;
      }
    },
    renderPieChart() {
      const ctx = document.getElementById("incomePieChart");
      if (!ctx) return;
      const existing = Chart.getChart("incomePieChart");
      if (existing) existing.destroy();

      if (this.challengeData.total === 0) return;

      // 动态构建数据：过滤掉金额为 0 的分类
      const rawItems = [
        { label: "挑战收入", value: this.challengeData.challengeFee, color: "#cb0c9f" },
        { label: "直购收入", value: this.challengeData.directFee, color: "#3A416F" },
        { label: "充值收入", value: this.challengeData.rechargeFee, color: "#189887" },
      ];
      const items = rawItems.filter((d) => d.value > 0);
      const labels = items.map((d) => d.label);
      const dataValues = items.map((d) => d.value);
      const colors = items.map((d) => d.color);

      // 自定义插件：在饼图扇区上绘制金额和百分比
      const pieLabelPlugin = {
        id: "pieLabels",
        afterDatasetsDraw(chart) {
          const { ctx } = chart;
          const meta = chart.getDatasetMeta(0);
          const total = chart.data.datasets[0].data.reduce((a, b) => a + b, 0);
          meta.data.forEach((arc, index) => {
            const value = chart.data.datasets[0].data[index];
            if (value === 0 || total === 0) return;
            const percentage = ((value / total) * 100).toFixed(1);
            const amount = (value / 100).toFixed(2);
            const props = arc.getProps(["x", "y", "startAngle", "endAngle", "outerRadius"]);
            const midAngle = (props.startAngle + props.endAngle) / 2;
            const labelRadius = props.outerRadius * 0.62;
            const lx = props.x + Math.cos(midAngle) * labelRadius;
            const ly = props.y + Math.sin(midAngle) * labelRadius;
            ctx.save();
            ctx.fillStyle = "#fff";
            ctx.textAlign = "center";
            ctx.textBaseline = "middle";
            ctx.font = "bold 13px sans-serif";
            ctx.fillText("¥" + amount, lx, ly - 9);
            ctx.font = "11px sans-serif";
            ctx.fillText(percentage + "%", lx, ly + 9);
            ctx.restore();
          });
        },
      };

      new Chart(ctx.getContext("2d"), {
        type: "pie",
        data: {
          labels: labels,
          datasets: [{
            data: dataValues,
            backgroundColor: colors,
          }],
        },
        plugins: [pieLabelPlugin],
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: { position: "bottom", labels: { font: { size: 11 } } },
            tooltip: {
              callbacks: {
                label(context) {
                  const v = context.parsed;
                  return context.label + ": ¥" + (v / 100).toFixed(2);
                },
              },
            },
          },
        },
      });
    },
    renderTrendChart() {
      const ctx = document.getElementById("overviewTrendChart");
      if (!ctx) return;
      const existing = Chart.getChart("overviewTrendChart");
      if (existing) existing.destroy();

      if (this.trendData.length === 0) return;

      new Chart(ctx.getContext("2d"), {
        type: "line",
        data: {
          labels: this.trendData.map((d) => d.date),
          datasets: [{
            label: "交易额(分)",
            data: this.trendData.map((d) => d.fee),
            borderColor: "#cb0c9f",
            backgroundColor: "rgba(203,12,159,0.1)",
            fill: true,
            tension: 0.4,
            pointRadius: 0,
            borderWidth: 2,
          }],
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: { legend: { display: false } },
          scales: {
            y: { grid: { borderDash: [5, 5] }, ticks: { color: "#b2b9bf", font: { size: 11 } } },
            x: { grid: { display: false }, ticks: { color: "#b2b9bf", font: { size: 11 } } },
          },
        },
      });
    },
  },
};
</script>
